//Es importante modificar el valor del atributo que define el color del icono (fill o stroke) de la fuente del
//icono a "currentColor" para poder controlar el color desde el componente.
//¡¡¡ No modificar este componente directamente !!! Usar IconBaseCode
//* Para actualizar la lista de iconos ejecutar yarn update-icons

import React from 'react';
import PropTypes from 'prop-types';
import styles from './style/icon_style.module.scss';
import Foundation, { FOUNDATION_PROPTYPES } from '../Foundation'
import {ReactComponent as ApplicationBath} from './assets/application_bath.svg';
import {ReactComponent as ApplicationCladding} from './assets/application_cladding.svg';
import {ReactComponent as ApplicationFacade} from './assets/application_facade.svg';
import {ReactComponent as ApplicationFlooring} from './assets/application_flooring.svg';
import {ReactComponent as ApplicationFurniture} from './assets/application_furniture.svg';
import {ReactComponent as ApplicationShower} from './assets/application_shower.svg';
import {ReactComponent as ApplicationStaircase} from './assets/application_staircase.svg';
import {ReactComponent as ApplicationTop} from './assets/application_top.svg';
import {ReactComponent as ArrowLarge} from './assets/arrow_large.svg';
import {ReactComponent as ArrowLargeInverse} from './assets/arrow_large_inverse.svg';
import {ReactComponent as ArrowShort} from './assets/arrow_short.svg';
import {ReactComponent as ArrowShortInverse} from './assets/arrow_short_inverse.svg';
import {ReactComponent as ChevronDown} from './assets/chevron_down.svg';
import {ReactComponent as ChevronLeft} from './assets/chevron_left.svg';
import {ReactComponent as ChevronRight} from './assets/chevron_right.svg';
import {ReactComponent as ChevronUp} from './assets/chevron_up.svg';
import {ReactComponent as Download} from './assets/download.svg';
import {ReactComponent as Expand} from './assets/expand.svg';
import {ReactComponent as LogoScalea} from './assets/logo_scalea.svg';
import {ReactComponent as LogoSensa} from './assets/logo_sensa.svg';
import {ReactComponent as ShoppingCart} from './assets/shopping_cart.svg';
import {ReactComponent as TypeInOut} from './assets/type_in_out.svg';
import {ReactComponent as TypeLow} from './assets/type_low.svg';
import {ReactComponent as TypeQuality} from './assets/type_quality.svg';
import {ReactComponent as TypeStain} from './assets/type_stain.svg';
import {ReactComponent as TypeTime} from './assets/type_time.svg';
import {ReactComponent as TypeUnique} from './assets/type_unique.svg';
import {ReactComponent as View1} from './assets/view_1.svg';
import {ReactComponent as View2} from './assets/view_2.svg';

export const IconMap = {
    application_bath: ApplicationBath,
	application_cladding: ApplicationCladding,
	application_facade: ApplicationFacade,
	application_flooring: ApplicationFlooring,
	application_furniture: ApplicationFurniture,
	application_shower: ApplicationShower,
	application_staircase: ApplicationStaircase,
	application_top: ApplicationTop,
	arrow_large: ArrowLarge,
	arrow_large_inverse: ArrowLargeInverse,
	arrow_short: ArrowShort,
	arrow_short_inverse: ArrowShortInverse,
	chevron_down: ChevronDown,
	chevron_left: ChevronLeft,
	chevron_right: ChevronRight,
	chevron_up: ChevronUp,
	download: Download,
	expand: Expand,
	logo_scalea: LogoScalea,
	logo_sensa: LogoSensa,
	shopping_cart: ShoppingCart,
	type_in_out: TypeInOut,
	type_low: TypeLow,
	type_quality: TypeQuality,
	type_stain: TypeStain,
	type_time: TypeTime,
	type_unique: TypeUnique,
	view_1: View1,
	view_2: View2
}

const DEFAULT_SIZE = 32

const Icon = (props) => {

	const { img, size = DEFAULT_SIZE, contain, ...rest } = props;
    const SvgIcon = IconMap[img]
    if (!SvgIcon) return null

    return  (
        <Foundation {...rest}>
            <SvgIcon className={styles.icon}
					 width={size}
					 {...!contain && {height:size}}
					 {...rest}
			/>
        </Foundation>
    )
}

export const ICON_PROPTYPES = {
	img: PropTypes.oneOf(Object.keys(IconMap)).isRequired,
	size: PropTypes.string
}

Icon.propTypes = {
	...ICON_PROPTYPES,
	...FOUNDATION_PROPTYPES,
}


export default Icon;
